module.exports = "<h3 class=\"footer\"> VinotintosMLB </h3>"